import { Box, Stack, Typography } from '@mui/material'
import { FC } from 'react'
import { getPxAsRem } from 'shared/utils'
import { ResultItem } from './ResultItem'
import { RecentlyVisitedItem } from './types'

interface RecentlyVisitedProps {
    items: RecentlyVisitedItem[]
    onSelect: () => void
    highlightedRow?: number
}

export const RecentlyVisited: FC<RecentlyVisitedProps> = ({
    items,
    onSelect,
    highlightedRow,
}) => {
    const isEmpty = items.length === 0

    return (
        <Box>
            <Typography
                variant="caption"
                color="text.secondary"
                fontWeight={600}
                sx={{
                    display: 'block',
                    padding: getPxAsRem(8, 12, 4),
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em',
                }}
            >
                Recently Visited
            </Typography>
            {isEmpty ? (
                <Box padding={getPxAsRem(8, 12)}>
                    <Typography variant="body2" color="text.disabled">
                        No recently visited pages
                    </Typography>
                </Box>
            ) : (
                <Stack>
                    {items.map((item, index) => (
                        <ResultItem
                            key={`${item.type}-${item.id}`}
                            type={item.type}
                            name={item.name}
                            subtitle={item.subtitle}
                            path={item.path}
                            onSelect={onSelect}
                            isHighlighted={index === highlightedRow}
                        />
                    ))}
                </Stack>
            )}
        </Box>
    )
}
